<template>

    <v-button-toolbar class="w-fluid">
        <v-select
            class="w-100p"
            :subload-url="`projects/${project.id}/forms?paginate=0`"
            :subload-key="'display_name'"
            :model="model"
            @input="$emit('input', $event)">
        </v-select>
        <v-button-icon
            icon="fas fa-arrow-up-right-from-square"
            size="md"
            width="50px"
            height="50px"
            @click.native="_openLink(reviewLink ?? selectedForm.review_link);">
        </v-button-icon>
    </v-button-toolbar>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        reviewLink: {
            type: String,
        },
    },

    computed: {

        forms() {
            return this.project.forms;
        },

        defaultForm() {
            return this.forms.find(f => f.is_default);
        },

        selectedForm() {
            const id = this.model ? parseInt(this.model) : null;
            return this.forms.find(f => parseInt(f.id) === id) || this.defaultForm;
        },

    },

    created() {
        if (this.model === null || this.model === undefined || this.model === '') {
            this.$emit('input', this.defaultForm ? this.defaultForm.id : null);
        }
    },

}

</script>
